import BaseService from '../../base/base_service';
import _ from '../../utils/underscore';
import DOM from '../../utils/dom';
import Strings from '../../utils/strings';
import ILanguageService from './language_service_interface';


export interface LanguageServiceParams {
    iso3: string;
    iso2: string;
    isRTL: boolean;
    text: {[key: string]: string};
};


/**
 *
 * Language class is used for string translation
 *
 */
export default class LanguageService extends BaseService implements ILanguageService {
    static CLASS = 'LanguageService';


    private _params: LanguageServiceParams = null;


    init(params: LanguageServiceParams) {
        super.init(params);

        this._params = params || {} as LanguageServiceParams;
        this._setRTLLanguageClass();
    }

    getIsRTL(): boolean {
        return this._params.isRTL;
    }

    getISO3(): string {
        return this._params.iso3;
    }

    getISO2(): string {
        return this._params.iso2;
    }


    translation(key: string, params?: {[key: string]: any}): string {
        if (_.isNullOrUndefined(key)) {
            this.logger.error('The key to translate is null or undefined, key: ' + key);
            return '';
        }

        key = key.toString().trim().toLowerCase();
        if (_.isEmpty(key)) {
            this.logger.error('The key to translate is empty');
            return '';
        }

        const text = this._params.text;

        if (!text) {
            this.logger.error(`There are no translation for ${this._params.iso3} language`);
            return '';
        }

        if (!text[key]) {
            this.logger.error(`The key ${key} does not exists in the translation`);
            return '';
        }

        const textTemplate = text[key];
        if (params) {
            return new Strings(textTemplate).injectIntoCurly(params);
        } else {
            return textTemplate;
        }
    }

    private _setRTLLanguageClass(): void {
        const CGP_RTL = 'cgp-rtl';
        if (this._params.isRTL) {
            DOM.addClass(DOM.getHTML(), CGP_RTL);
        } else {
            DOM.removeClass(DOM.getHTML(), CGP_RTL);
        }
    }
}
